import { RED_COUNTS, type RedCount } from '@aiscoreboard/contracts';
import { useT } from '../lib/i18n';

export function RedCountStepper({
  value,
  onChange,
}: {
  value: RedCount;
  onChange: (value: RedCount) => void;
}) {
  const t = useT();
  const index = RED_COUNTS.indexOf(value);
  const fewer = RED_COUNTS[index - 1];
  const more = RED_COUNTS[index + 1];

  return (
    <div className="flex w-full flex-col items-center gap-1.5">
      <span className="label mb-0 text-center">{t('reds.label')}</span>
      <div className="flex w-full items-center justify-center gap-2">
        <button
          type="button"
          disabled={fewer === undefined}
          onClick={() => fewer !== undefined && onChange(fewer)}
          aria-label={t('reds.fewer')}
          className="step-btn h-11 w-11 text-xl"
        >
          −
        </button>
        <output aria-label={t('reds.label')} aria-live="polite"
          className="field num-lg w-16 shrink-0 px-2 text-center text-2xl">
          {value}
        </output>
        <button
          type="button"
          disabled={more === undefined}
          onClick={() => more !== undefined && onChange(more)}
          aria-label={t('reds.more')}
          className="step-btn h-11 w-11 text-xl"
        >
          +
        </button>
      </div>
    </div>
  );
}
